import { createAction } from '@reduxjs/toolkit';

export const openBulletinDialog = createAction(
  'bulletinBoard/bulletins/openBulletinDialog'
);
export const closeBulletinDialog = createAction(
  'bulletinBoard/bulletins/closeBulletinDialog'
);

export const openCreateBulletin = createAction(
  'bulletinBoard/bulletins/openCreateBulletin'
);

export const openJoiningInstructionDialog = createAction(
  'bulletinBoard/bulletins/openJoiningInstructionDialog'
);

export const closeJoiningInstructionDialog = createAction(
  'bulletinBoard/bulletins/closeJoiningInstructionDialog'
);

export const closeCreateBulletin = createAction(
  'bulletinBoard/bulletins/closeCreateBulletin'
);

export const openImageSelector = createAction(
  'bulletinBoard/bulletins/openImageSelector'
);

export const closeImageSelector = createAction(
  'bulletinBoard/bulletins/closeImageSelector'
);

export const resetBulletinData = createAction(
  'bulletinBoard/bulletins/resetBulletinData'
);

export const openEditBulletin = createAction(
  'bulletinBoard/bulletins/openEditBulletin'
);

export const closeEditBulletin = createAction(
  'bulletinBoard/bulletins/closeEditBulletin'
);

export const openDeleteBulletinDialog = createAction(
  'bulletinBoard/bulletins/openDeleteBulletinDialog'
);

export const closeDeleteBulletinDialog = createAction(
  'bulletinBoard/bulletins/closeDeleteBulletinDialog'
);

export const openSendBulletin = createAction(
  'bulletinBoard/bulletins/openSendBulletin'
);

export const closeSendBulletin = createAction(
  'bulletinBoard/bulletins/closeSendBulletin'
);

export const addFilepermissionUrl = createAction(
  'bulletinBoard/bulletins/addFilepermissionUrl'
);

export const resetFilepermissionUrls = createAction(
  'bulletinBoard/bulletins/resetFilepermissionUrls'
);

export const setLoadingPdf = createAction(
  'bulletinBoard/bulletins/setLoadingPdf'
);

export const openAddEmailDialog = createAction(
  'bulletinBoard/bulletins/openAddEmailDialog'
);

export const closeAddEmailDialog = createAction(
  'bulletinBoard/bulletins/closeAddEmailDialog'
);

export const setBulletinImageUrls = createAction(
  'bulletinBoard/bulletins/setBulletinImageUrls'
);

export const setLastOpenedBulletinId = createAction(
  'bulletinBoard/bulletins/setLastOpenedBulletinId'
);

/** Show a bulletin a background write just changed. Policy lives in the slice. */
export const revealBulletin = createAction(
  'bulletinBoard/bulletins/revealBulletin'
);

/**
 * Drop a bulletin a background write deleted. Payload is the id.
 *
 * Separate from `revealBulletin` because the two answer different questions:
 * that one decides whether to move the view and only the board can say, this
 * one states that a row is gone, which is true whatever is on screen.
 */
export const removeBulletin = createAction(
  'bulletinBoard/bulletins/removeBulletin'
);

/**
 * A bulletin written outside the board — by Nerobotti — for the user to edit
 * and save. Payload `{ projectId, header, content, photos, receivedAt }`, the
 * text plain with a blank line between paragraphs, the photos `{ id, name }`.
 *
 * Policy lives in the slice: opened in the create editor when the board is
 * showing that project, kept for it otherwise. Nothing is saved by this; the
 * bulletin exists only if the user saves it.
 */
export const receiveBulletinDraft = createAction(
  'bulletinBoard/bulletins/receiveBulletinDraft'
);

/**
 * The board, now showing a project, asking for the draft waiting for it.
 * Payload `{ projectId, now }`; `now` lets the slice drop a draft too old to
 * still be what the user meant.
 */
export const openPendingBulletinDraft = createAction(
  'bulletinBoard/bulletins/openPendingBulletinDraft'
);

/**
 * The user, offered a draft over an editor that holds something else, choosing
 * the draft. It takes the editor whatever is in it.
 */
export const acceptPendingBulletinDraft = createAction(
  'bulletinBoard/bulletins/acceptPendingBulletinDraft'
);

/** The same offer, declined. The editor keeps what the user has. */
export const discardPendingBulletinDraft = createAction(
  'bulletinBoard/bulletins/discardPendingBulletinDraft'
);

/**
 * What the create editor holds right now — `{ projectId, header, content }`,
 * the content as the editor stores it. Kept in the store so a message to
 * Nerobotti can carry it, and so a draft coming back can be checked against it.
 */
export const setComposingBulletin = createAction(
  'bulletinBoard/bulletins/setComposingBulletin'
);

export const setOpenAttachmentDeleteDialog = createAction(
  'bulletinBoard/bulletins/setOpenAttachmentDeleteDialog'
);

export const addAttachments = createAction(
  'bulletinBoard/bulletins/addAttachments'
);

export const openEditRecipientResourceDialog = createAction(
  'bulletinBoard/openEditRecipientResourceDialog'
);

export const closeEditRecipientResourceDialog = createAction(
  'bulletinBoard/closeEditRecipientResourceDialog'
);
